/**
 * Vista: Gestión de Catálogo de Almacenes
 * CRUD completo para administrar almacenes/ubicaciones
 */

import almacenService from '../services/almacen.service.js';
import api from '../services/api.js';
import permisos from '../services/permissions.service.js';
import modal from '../utils/modal.js';

export default {
  data: {
    almacenes: [],
    loading: true,
    showModal: false,
    editingAlmacen: null,
    filters: {
      search: '',
      activo: ''
    },
    stats: {},
    responsables: []
  },

  async render() {
    return `
      <div class="page-header">
        <h1>Catálogo de Almacenes</h1>
        ${permisos.canCreate('almacenes') ? `
          <button class="btn btn-primary" id="btnNuevoAlmacen">
            <span class="icon">➕</span> Nuevo Almacén
          </button>
        ` : ''}
      </div>

      <!-- Estadísticas -->
      <div class="stats-grid" id="statsContainer">
        <div class="loading-spinner"></div>
      </div>

      <!-- Filtros -->
      <div class="filters-card">
        <div class="filters-grid">
          <div class="form-group">
            <label>Buscar</label>
            <input
              type="text"
              id="searchInput"
              placeholder="Código, nombre o ubicación..."
              class="form-control"
            />
          </div>

          <div class="form-group">
            <label>Estado</label>
            <select id="activoFilter" class="form-control">
              <option value="">Todos</option>
              <option value="true">Activos</option>
              <option value="false">Inactivos</option>
            </select>
          </div>

          <div class="form-group" style="display: flex; align-items: flex-end;">
            <button class="btn btn-secondary" id="btnLimpiarFiltros">
              Limpiar
            </button>
          </div>
        </div>
      </div>

      <!-- Tabla de almacenes -->
      <div class="card">
        <div class="table-container">
          <table class="table">
            <thead>
              <tr>
                <th></th>
                <th>Código</th>
                <th class="tbl-hide-mobile">Nombre</th>
                <th class="tbl-hide-mobile">Ubicación</th>
                <th class="tbl-hide-mobile">Capacidad</th>
                <th class="tbl-hide-mobile">Responsable</th>
                <th class="tbl-hide-mobile">Estado</th>
                <th class="tbl-hide-mobile">Acciones</th>
              </tr>
            </thead>
            <tbody id="almacenesTableBody">
              <tr>
                <td colspan="8" class="text-center">
                  <div class="loading-spinner"></div>
                  <p>Cargando almacenes...</p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- Modal para crear/editar -->
      <div id="almacenModal" class="modal" style="display: none;">
        <div class="modal-content">
          <div class="modal-header">
            <h2 id="modalTitle">Nuevo Almacén</h2>
            <button class="modal-close" id="btnCerrarModal">&times;</button>
          </div>

          <form id="almacenForm">
            <div class="modal-body">
              <div class="form-row">
                <div class="form-group">
                  <label>Nombre *</label>
                  <input
                    type="text"
                    id="nombre"
                    class="form-control"
                    required
                    placeholder="Almacén Principal"
                  />
                </div>
              </div>

              <div class="form-group">
                <label>Descripción</label>
                <textarea
                  id="descripcion"
                  class="form-control"
                  rows="2"
                  placeholder="Descripción del almacén..."
                ></textarea>
              </div>

              <div class="form-group">
                <label>Ubicación</label>
                <input
                  type="text"
                  id="ubicacion"
                  class="form-control"
                  placeholder="Planta AGROMX - Área A"
                />
              </div>

              <div class="form-row">
                <div class="form-group">
                  <label>Capacidad</label>
                  <input
                    type="number"
                    id="capacidad"
                    class="form-control"
                    min="1"
                    max="1000"
                    placeholder="50"
                  />
                  <small>Capacidad en unidades</small>
                </div>

                <div class="form-group">
                  <label>Responsable</label>
                  <select id="responsable_id" class="form-control">
                    <option value="">Sin asignar</option>
                  </select>
                </div>
              </div>

              <div class="form-group">
                <label>Teléfono</label>
                <input
                  type="tel"
                  id="telefono"
                  class="form-control"
                  placeholder="555-1234"
                />
              </div>
            </div>

            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" id="btnCancelar">
                Cancelar
              </button>
              <button type="submit" class="btn btn-primary">
                <span class="icon">💾</span> Guardar
              </button>
            </div>
          </form>
        </div>
      </div>
    `;
  },

  async afterRender() {
    if (!permisos.canView('almacenes')) {
      if (permisos.primeraRuta) { router.navigate(permisos.primeraRuta); }
      else { document.getElementById('content').innerHTML = '<div style="display:flex;justify-content:center;align-items:center;height:60vh;"><div style="text-align:center;color:var(--primary);"><h2>Acceso denegado</h2><p>No tienes permisos para acceder a este módulo.</p></div></div>'; }
      return;
    }
    window.currentView = this;
    await this.cargarEstadisticas();
    await this.cargarAlmacenes();
    this.setupEventListeners();
  },

  setupEventListeners() {
    document.getElementById('btnNuevoAlmacen')?.addEventListener('click', () => {
      this.abrirModal();
    });

    document.getElementById('btnCerrarModal')?.addEventListener('click', () => {
      this.cerrarModal();
    });

    document.getElementById('btnCancelar')?.addEventListener('click', () => {
      this.cerrarModal();
    });

    document.getElementById('almacenForm')?.addEventListener('submit', (e) => {
      e.preventDefault();
      this.guardarAlmacen();
    });

    document.getElementById('searchInput')?.addEventListener('input', (e) => {
      this.data.filters.search = e.target.value;
      this.aplicarFiltros();
    });

    document.getElementById('activoFilter')?.addEventListener('change', (e) => {
      this.data.filters.activo = e.target.value;
      this.aplicarFiltros();
    });

    document.getElementById('btnLimpiarFiltros')?.addEventListener('click', () => {
      this.limpiarFiltros();
    });

  },

  async cargarEstadisticas() {
    try {
      const response = await almacenService.obtenerEstadisticas();
      this.data.stats = response.data.stats;
      this.renderEstadisticas();
    } catch (error) {
      console.error('Error al cargar estadísticas:', error);
    }
  },

  renderEstadisticas() {
    const stats = this.data.stats;
    const container = document.getElementById('statsContainer');

    if (!container) return;

    container.innerHTML = `
      <div class="stat-card">
        <div class="stat-icon">📊</div>
        <div class="stat-content">
          <div class="stat-value">${stats.total || 0}</div>
          <div class="stat-label">Total Almacenes</div>
        </div>
      </div>

      <div class="stat-card stat-success">
        <div class="stat-icon">✅</div>
        <div class="stat-content">
          <div class="stat-value">${stats.activos || 0}</div>
          <div class="stat-label">Activos</div>
        </div>
      </div>

      <div class="stat-card stat-warning">
        <div class="stat-icon">⏸️</div>
        <div class="stat-content">
          <div class="stat-value">${stats.inactivos || 0}</div>
          <div class="stat-label">Inactivos</div>
        </div>
      </div>

      <div class="stat-card stat-info">
        <div class="stat-icon">📦</div>
        <div class="stat-content">
          <div class="stat-value">${stats.capacidad_total || 0}</div>
          <div class="stat-label">Capacidad Total</div>
        </div>
      </div>
    `;
  },

  async cargarAlmacenes() {
    this.data.loading = true;
    const tbody = document.getElementById('almacenesTableBody');

    try {
      const response = await almacenService.listar(this.data.filters);
      this.data.almacenes = response.data.almacenes || [];
      this.renderTabla();
    } catch (error) {
      console.error('Error al cargar almacenes:', error);
      if (tbody) {
        tbody.innerHTML = `
          <tr>
            <td colspan="8" class="text-center error-message">
              Error al cargar almacenes: ${error.message}
            </td>
          </tr>
        `;
      }
    } finally {
      this.data.loading = false;
    }
  },

  renderTabla() {
    const tbody = document.getElementById('almacenesTableBody');
    if (!tbody) return;

    if (!this.data.almacenes || this.data.almacenes.length === 0) {
      tbody.innerHTML = `
        <tr>
          <td colspan="8" class="text-center">
            No se encontraron almacenes
          </td>
        </tr>
      `;
      return;
    }

    tbody.innerHTML = this.data.almacenes.map(almacen => {
      const estadoBadge = `<span class="badge ${almacen.activo ? 'badge-success' : 'badge-secondary'}">${almacen.activo ? 'Activo' : 'Inactivo'}</span>`;
      const accionesHtml = `
        ${permisos.canEdit('almacenes') ? `<button class="btn-icon btn-edit" onclick="window.currentView.editarAlmacen(${almacen.id})" title="Editar">✏️</button>` : ''}
        ${permisos.can('almacenes', 'cambiar_estado') ? `<button class="btn-icon ${almacen.activo ? 'btn-warning' : 'btn-success'}" onclick="window.currentView.toggleActivo(${almacen.id})" title="${almacen.activo ? 'Desactivar' : 'Activar'}">${almacen.activo ? '⏸️' : '▶️'}</button>` : ''}
        ${permisos.canDelete('almacenes') ? `<button class="btn-icon btn-danger" onclick="window.currentView.eliminarAlmacen(${almacen.id})" title="Eliminar">🗑️</button>` : ''}
      `;
      return `
      <tr>
        <td><button class="tbl-expand-btn" onclick="window.currentView.toggleRow(${almacen.id})">&#9654;</button></td>
        <td><strong>${almacen.codigo}</strong></td>
        <td class="tbl-hide-mobile">${almacen.nombre}</td>
        <td class="tbl-hide-mobile">${almacen.ubicacion || '-'}</td>
        <td class="tbl-hide-mobile">${almacen.capacidad || '-'}</td>
        <td class="tbl-hide-mobile">${almacen.responsable_nombre || 'Sin asignar'}</td>
        <td class="tbl-hide-mobile">${estadoBadge}</td>
        <td class="tbl-hide-mobile">
          <div class="action-buttons">${accionesHtml}</div>
        </td>
      </tr>
      <tr class="tbl-detail-row" id="detail-alm-${almacen.id}">
        <td colspan="8" class="tbl-detail-cell">
          <dl class="tbl-detail-grid">
            <dt>Nombre</dt><dd>${almacen.nombre}</dd>
            <dt>Ubicación</dt><dd>${almacen.ubicacion || '-'}</dd>
            <dt>Capacidad</dt><dd>${almacen.capacidad || '-'}</dd>
            <dt>Responsable</dt><dd>${almacen.responsable_nombre || 'Sin asignar'}</dd>
            <dt>Estado</dt><dd>${estadoBadge}</dd>
          </dl>
          <div style="margin-top: var(--spacing-sm); display: flex; gap: var(--spacing-xs);">${accionesHtml}</div>
        </td>
      </tr>
    `}).join('');
  },

  toggleRow(id) {
    const detailRow = document.getElementById(`detail-alm-${id}`);
    const btn = detailRow?.previousElementSibling?.querySelector('.tbl-expand-btn');
    if (detailRow) {
      detailRow.classList.toggle('open');
      btn?.classList.toggle('open');
    }
  },

  async abrirModal(almacen = null) {
    this.data.editingAlmacen = almacen;
    const modal = document.getElementById('almacenModal');
    const title = document.getElementById('modalTitle');

    await this._cargarResponsables();

    if (almacen) {
      title.textContent = 'Editar Almacén';
      document.getElementById('nombre').value = almacen.nombre;
      document.getElementById('descripcion').value = almacen.descripcion || '';
      document.getElementById('ubicacion').value = almacen.ubicacion || '';
      document.getElementById('capacidad').value = almacen.capacidad || '';
      document.getElementById('responsable_id').value = almacen.responsable_id || '';
      document.getElementById('telefono').value = almacen.telefono || '';
    } else {
      title.textContent = 'Nuevo Almacén';
      document.getElementById('almacenForm').reset();
    }

    modal.style.display = 'flex';
  },

  async _cargarResponsables() {
    const select = document.getElementById('responsable_id');
    if (!select) return;
    try {
      if (!this.data.responsables.length) {
        const response = await api.get('/usuarios/responsables');
        // El endpoint devuelve response.data como array directo
        const todos = Array.isArray(response.data) ? response.data : (response.data?.usuarios || response.usuarios || []);
        // Solo usuarios con persona asociada
        this.data.responsables = todos.filter(u => u.persona_id);
      }
      select.innerHTML = `
        <option value="">Sin asignar</option>
        ${this.data.responsables.map(u => `
          <option value="${u.id}">${u.persona_nombre_completo || u.nombre_completo}</option>
        `).join('')}
      `;
    } catch (error) {
      console.error('Error al cargar responsables:', error);
      select.innerHTML = '<option value="">Error al cargar responsables</option>';
    }
  },

  cerrarModal() {
    const modal = document.getElementById('almacenModal');
    modal.style.display = 'none';
    document.getElementById('almacenForm').reset();
    this.data.editingAlmacen = null;
  },

  async guardarAlmacen() {
    const responsableVal = document.getElementById('responsable_id').value;
    const formData = {
      nombre: document.getElementById('nombre').value.trim(),
      descripcion: document.getElementById('descripcion').value.trim() || null,
      ubicacion: document.getElementById('ubicacion').value.trim() || null,
      capacidad: parseInt(document.getElementById('capacidad').value) || null,
      responsable_id: responsableVal ? parseInt(responsableVal, 10) : null,
      telefono: document.getElementById('telefono').value.trim() || null
    };

    try {
      if (this.data.editingAlmacen) {
        await almacenService.actualizar(this.data.editingAlmacen.id, formData);
        this.showNotification('Almacén actualizado exitosamente', 'success');
      } else {
        await almacenService.crear(formData);
        this.showNotification('Almacén creado exitosamente', 'success');
      }

      this.cerrarModal();
      await this.cargarAlmacenes();
      await this.cargarEstadisticas();
    } catch (error) {
      console.error('Error al guardar almacén:', error);
      this.showNotification(error.message || 'Error al guardar almacén', 'error');
    }
  },

  async editarAlmacen(id) {
    try {
      const response = await almacenService.obtenerPorId(id);
      this.abrirModal(response.data.almacen);
    } catch (error) {
      console.error('Error al cargar almacén:', error);
      this.showNotification('Error al cargar almacén', 'error');
    }
  },

  async toggleActivo(id) {
    const almacen = (this.data.almacenes || []).find(a => a.id === id);
    const nombre = almacen?.nombre || 'este almacén';
    const accion = almacen?.activo ? 'desactivar' : 'activar';
    modal.confirm(
      'Cambiar estado del almacén',
      `¿Está seguro de ${accion} a <strong>${nombre}</strong>?`,
      async () => {
        try {
          await almacenService.toggleActivo(id);
          this.showNotification('Estado actualizado', 'success');
          await this.cargarAlmacenes();
          await this.cargarEstadisticas();
        } catch (error) {
          console.error('Error:', error);
          this.showNotification('Error al cambiar estado', 'error');
        }
      }
    );
  },

  async eliminarAlmacen(id) {
    const almacen = (this.data.almacenes || []).find(a => a.id === id);
    const nombre = almacen?.nombre || 'este almacén';
    modal.confirm(
      'Confirmar eliminación',
      `¿Está seguro de eliminar a <strong>${nombre}</strong>? Esta acción no se puede deshacer.`,
      async () => {
        try {
          await almacenService.eliminar(id);
          this.showNotification('Almacén eliminado exitosamente', 'success');
          await this.cargarAlmacenes();
          await this.cargarEstadisticas();
        } catch (error) {
          console.error('Error:', error);
          this.showNotification(error.message || 'Error al eliminar almacén', 'error');
        }
      }
    );
  },

  aplicarFiltros() {
    this.cargarAlmacenes();
  },

  limpiarFiltros() {
    this.data.filters = {
      search: '',
      activo: ''
    };

    document.getElementById('searchInput').value = '';
    document.getElementById('activoFilter').value = '';

    this.cargarAlmacenes();
  },

  showNotification(message, type = 'info') {
    const notification = document.createElement('div');
    notification.className = `notification notification-${type}`;
    notification.textContent = message;
    document.body.appendChild(notification);

    setTimeout(() => {
      notification.remove();
    }, 3000);
  }
};
